import * as types from '../types/ui'

export const showAlert = payload => ( {
  type: types.SHOW_ALERT,
  payload: payload
} )

export const closeAlert = payload => ( {
  type: types.HIDE_ALERT,
  payload: payload
} )

export const setHeaderMode = type => ( {
  type: types.HEADER_MODE,
  payload: type
} )

export const toogleToolbar = show => ( {
  type: show ? types.SHOW_TOOLBAR : types.HIDE_TOOLBAR
} )

export const togglePopover = payload => ( {
  type: payload.show ? types.SHOW_POPOVER : types.HIDE_POPOVER,
  payload: payload.name
} )

export const toggleUploaderActive = payload => ( {
  type: types.SET_UPLOADER_ACTIVE,
  payload: payload
} )

export const toggleToaster = toaster => ( {
  type: toaster.isVisible ? types.SHOW_TOASTER : types.HIDE_TOASTER,
  payload: toaster
} )

export const toggleContextMenu = contextMenu => ( {
  type: contextMenu.show ? types.SHOW_CONTEXT_MENU : types.HIDE_CONTEXT_MENU,
  payload: contextMenu
} )

export const setForceUpdate = () => ( {
  type: types.FORCE_UPDATE
} )

export const toggleSaving = saving => ( {
  type: types.TOGGLE_SAVING,
  payload: saving
} )

export const toggleSidebar = sidebar => ( {
  type: types.TOGGLE_SIDEBAR,
  payload: sidebar
} )

export const togglePageOrder = payload => ( {
  type: types.TOGGLE_PAGE_ORDER,
  payload: payload
} )

export const showFileManager = opened => ( {
  type: types.SHOW_FILE_MANAGER,
  payload: opened
} )

export const setLockBackground = lock => ( {
  type: types.LOCK_BACKGROUND,
  payload: lock
} )

export const setZoom = zoom => ( {
  type: types.SET_ZOOM,
  payload: zoom
} )

export const setZoomableInstance = instance => ( {
  type: types.SET_ZOOMABLE_INSTANCE,
  payload: instance
} )



// WEBPACK FOOTER //
// ./src/store/actions/ui.js